// create canned services
export const CREATE_CANNED_SERVICES_REQUEST = 'CREATE_CANNED_SERVICES_REQUEST';
export const CREATE_CANNED_SERVICES_SUCCESS = 'CREATE_CANNED_SERVICES_SUCCESS';
export const CREATE_CANNED_SERVICES_FAIL = 'CREATE_CANNED_SERVICES_FAIL';

// create estimator jobs
export const CREATE_ESTIMATOR_JOB_REQUEST = 'CREATE_ESTIMATOR_JOB_REQUEST';
export const CREATE_ESTIMATOR_JOB_SUCCESS = 'CREATE_ESTIMATOR_JOB_SUCCESS';
export const CREATE_ESTIMATOR_JOB_FAIL = 'CREATE_ESTIMATOR_JOB_FAIL';

// create estimator
export const CREATE_ESTIMATOR_REQUEST = 'CREATE_ESTIMATOR_REQUEST';
export const CREATE_ESTIMATOR_SUCCESS = 'CREATE_ESTIMATOR_SUCCESS';
export const CREATE_ESTIMATOR_FAIL = 'CREATE_ESTIMATOR_FAIL';
export const CLEAR_CREATE_ESTIMATOR_STATES = 'CLEAR_CREATE_ESTIMATOR_STATES';

// SAVE item to inventory
export const SAVE_ITEM_TO_INVENTORY_REQUEST = 'SAVE_ITEM_TO_INVENTORY_REQUEST';
export const SAVE_ITEM_TO_INVENTORY_SUCCESS = 'SAVE_ITEM_TO_INVENTORY_SUCCESS';
export const SAVE_ITEM_TO_INVENTORY_FAIL = 'SAVE_ITEM_TO_INVENTORY_FAIL';

// get estimates
export const GET_ESTIMATES_REQUEST = 'GET_ESTIMATES_REQUEST';
export const GET_ESTIMATES_SUCCESS = 'GET_ESTIMATES_SUCCESS';
export const GET_ESTIMATES_FAIL = 'GET_ESTIMATES_FAIL';

// get estimate
export const GET_ESTIMATE_REQUEST = 'GET_ESTIMATE_REQUEST';
export const GET_ESTIMATE_SUCCESS = 'GET_ESTIMATE_SUCCESS';
export const GET_ESTIMATE_FAIL = 'GET_ESTIMATE_FAIL';

// delete estimate
export const DELETE_ESTIMATE_REQUEST = 'DELETE_ESTIMATE_REQUEST';
export const DELETE_ESTIMATE_SUCCESS = 'DELETE_ESTIMATE_SUCCESS';
export const DELETE_ESTIMATE_FAIL = 'DELETE_ESTIMATE_FAIL';
export const UPDATE_LIST_ON_DELETE_ESTIMATE = 'UPDATE_LIST_ON_DELETE_ESTIMATE';

export const CLEAR_DELETED_ESTIMATE_STATE = 'CLEAR_DELETED_ESTIMATE_STATE';

// convert to ro
export const CONVERT_TO_RO_REQUEST = 'CONVERT_TO_RO_REQUEST';
export const CONVERT_TO_RO_SUCCESS = 'CONVERT_TO_RO_SUCCESS';
export const CONVERT_TO_RO_FAIL = 'CONVERT_TO_RO_FAIL';

// authorize estimate
export const AUTHORIZE_ESTIMATOR_REQUEST = 'AUTHORIZE_ESTIMATOR_REQUEST';
export const AUTHORIZE_ESTIMATOR_SUCCESS = 'AUTHORIZE_ESTIMATOR_SUCCESS';
export const AUTHORIZE_ESTIMATOR_FAIL = 'AUTHORIZE_ESTIMATOR_FAIL';
export const CLEAR_AUTHORIZE_ESTIMATOR_STATESL =
  'CLEAR_AUTHORIZE_ESTIMATOR_STATESL';

// clearing created job state
export const CLEAR_ESTIMATOR_STATE = 'CLEAR_ESTIMATOR_STATE';

// navBar state for GrossProfitBar
export const NAV_BAR_STATE = 'NAV_BAR_STATE';

export const UPDATE_ESTIMATOR_JOB_LIST = 'UPDATE_ESTIMATOR_JOB_LIST';
